import { render } from "./ReviewAndSubmit.vue?vue&type=template&id=832800fa"
import script from "./ReviewAndSubmit.vue?vue&type=script&lang=js"
export * from "./ReviewAndSubmit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__